import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/app/college-ambassadors/AmbassadorsContent.tsx");
